/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link as ReactRouterLink } from 'react-router';

import { Grid, Link, Typography2 } from '@coursera/cds-core';

import constants from 'bundles/directory-graphql/common/constants';

export type TitledLink = {
  title?: string;
  link: string;
};

export type Props = {
  titledLinks: Array<TitledLink | null> | null;
};

const styles = {
  results: css`
    padding-top: 16px;
    padding-bottom: 32px;
  `,
  linksContainer: css`
    margin-bottom: 24px;
  `,
  row: css`
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  `,
  resultsContainer: css`
    @media (min-width: 768px) {
      width: 50%;
      float: left;
      position: relative;
      min-height: 1px;
      padding-left: 15px;
      padding-right: 15px;
    }
  `,
};

export const LinksColumn = ({ titledLinks = [] }: Props) => {
  const isDirectoryLink = (link: string) => link.indexOf(constants.root) === 0;

  if (titledLinks === null || !titledLinks.length) {
    return null;
  }

  return (
    <div data-testid="linksColumn" css={styles.resultsContainer}>
      <ul>
        {titledLinks.map((m) => {
          if (m === null) {
            return null;
          }
          return (
            <Typography2 component="li">
              {isDirectoryLink(m.link) ? (
                <Link to={m.link} typographyVariant="bodyPrimary" component={ReactRouterLink} variant="quiet">
                  {m.title}
                </Link>
              ) : (
                <Link typographyVariant="bodySecondary" href={m.link} variant="quiet">
                  {m.title}
                </Link>
              )}
            </Typography2>
          );
        })}
      </ul>
    </div>
  );
};

const LinksContainer = ({ titledLinks = [] }: Props) => {
  if (titledLinks === null) {
    return null;
  }

  const numLinks = titledLinks.length;

  if (!numLinks) {
    return null;
  }

  const sliceAt = Math.max(numLinks / 2);

  const titledLinks1 = titledLinks.slice(0, sliceAt);
  const titledLinks2 = titledLinks.slice(sliceAt);
  return (
    <Grid item container css={styles.linksContainer}>
      <Grid item css={styles.row}>
        <LinksColumn titledLinks={titledLinks1} />
        <LinksColumn titledLinks={titledLinks2} />
      </Grid>
    </Grid>
  );
};

export default LinksContainer;
